import useLiveChatDeepLink from 'components/LiveChat/useLiveChatDeepLink';

/**
 * Invisible mount component for the LiveChat deep-link feature. Rendered inside
 * `LiveChatContainer` (inside the provider) so it can consume the LiveChat
 * context. Its only job is to run `useLiveChatDeepLink()`; it renders nothing.
 *
 * Named `...Mount` to avoid a case-insensitive filesystem collision with the
 * lowercase helper module `liveChatDeepLink.js`.
 */
const LiveChatDeepLinkMount = () => {
  useLiveChatDeepLink();

  return null;
};

export default LiveChatDeepLinkMount;
